import { render, staticRenderFns } from "./OrganizationTeams.vue?vue&type=template&id=16f40dcb&scoped=true&"
import script from "./OrganizationTeams.vue?vue&type=script&lang=js&"
export * from "./OrganizationTeams.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationTeams.vue?vue&type=style&index=0&id=16f40dcb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f40dcb",
  null
  
)

export default component.exports